(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.sidebar = {
    attach: function (context) {

      $(".paragraph--type--sidebar li.has-children").click(function(e) {
        if($(this).next().is(":visible")) {
          $(this).next().slideUp();
          $(this).removeClass("sidebar-open");
        } else {
          $(this).next().slideDown();
          $(this).addClass("sidebar-open");
        }
      });


    },
  };
})(jQuery, Drupal);
